import Index from '../components/CategoryRecipeOrder/Index';

let routes = {
    path: '/categoryRecipeOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/categoryRecipeOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/categoryRecipeOrder.js